import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import About from '../../components/about';
import ServiceSection from '../../components/Services';
import FunFact from '../../components/FunFact';
// import TeamSection from '../../components/TeamSection';
import Testimonial from '../../components/Testimonial';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'
import MAAKLOGO from '../../images/UpComing-Projects/PHOTO-2025-08-04-11-24-16.jpg';

const AboutPage = () => {
    return (
        <Fragment>
            <Navbar Logo={Logo} hclass={'header-style-1'} />
            <About abimg={MAAKLOGO} />
            <ServiceSection />
            <FunFact />
            {/* <TeamSection/> */}
            <Testimonial />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
